import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonsModule, IconModule } from 'axis-components';
import { Logger } from '../_core/logger.service';
import { HeaderSharedService } from '../_services/header-shared.service';
import { RequestService } from '../_services/request/request.service';
import { UserService } from '../_services/user.service';
import { FormType, RequestProgressStep } from '../config/constants';
@Component({
  selector: 'app-home',
  standalone: true,
  host: { class: '_display-flex-grow _bg-primary' },
  styleUrl: './home.component.scss',
  templateUrl: './home.component.html',
  imports: [ButtonsModule, IconModule, RouterModule],
})
export class HomeComponent implements OnInit {
  sub: any;
  broker: string = '';
  requestKey: string | null = null;

  hasUMUIM = true;
  hasPIP = true;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private userService: UserService,
    private requestService: RequestService,
    // private pdfService: PdfService,
    private http: HttpClient,
    private headerService: HeaderSharedService,
  ) {}

  ngOnInit(): void {
    this.requestKey = this.requestService.getRequestKey();
    // this.runPdfChecks();
    this.userService.role = this.requestService.getUserRole();

    this.hasUMUIM = this.requestService.requestFormTypeList.includes(
      FormType.UM_UIM,
    );
    this.hasPIP = this.requestService.requestFormTypeList.includes(
      FormType.PIP,
    );
  }

  btnStart_clickHandler(event) {
    event.preventDefault();
    const formTypeList = this.requestService.requestFormTypeList;
    if (formTypeList.length === 0) {
      return;
    }
    this.routeBasedOnCurrentState();
    /*
    const ft = formTypeList[0].toLowerCase();
    if (ft === 'pip') {
      this.router.navigate(['/insured/pip-consent'], {
        queryParams: { key: this.requestKey },
      });
    } else if (ft === 'um_uim') {
      this.router.navigate(['/insured/uimui-consent'], {
        queryParams: { key: this.requestKey },
      });
    }
      */
  }

  routeBasedOnCurrentState() {
    const formTypeStepList = this.requestService.formTypeStep;
    if (!formTypeStepList || formTypeStepList.length === 0) {
      return;
    }

    if (
      window.location.href.search('skipRequestStatusCheck=true') >= 0 &&
      (window.location.origin.toLowerCase().includes('dev.digisign') ||
        window.location.origin.toLowerCase().includes('localhost') ||
        window.location.origin.toLowerCase().includes('qa.digisign'))
    ) {
      Logger.log('Skipping request status check as per URL parameter');
      if (formTypeStepList.length === 1) {
        const formType = formTypeStepList[0].formType.toLowerCase();
        if (formType === 'um_uim') {
          this.router.navigate(['/insured/uimui-consent'], {
            queryParamsHandling: 'preserve',
          });
        } else if (formType === 'pip') {
          this.router.navigate(['/insured/pip-consent'], {
            queryParamsHandling: 'preserve',
          });
        }
        return;
      }
      if (formTypeStepList.length === 2) {
        this.router.navigate(['/insured/uimui-consent'], {
          queryParams: { key: this.requestKey },
          queryParamsHandling: 'preserve',
        });
        return;
      }
      return;
    }

    if (formTypeStepList.length === 1) {
      const formType = formTypeStepList[0].formType.toLowerCase();
      const step = formTypeStepList[0].step;
      if (this.requestService.isFormTypeCompleted(step)) {
        this.router.navigate(['thank-you'], {
          queryParamsHandling: 'preserve',
        });
        // this.router.navigate(['404']);
        return;
      } else {
        if (formType === 'um_uim') {
          this.router.navigate(['/insured/uimui-consent'], {
            queryParamsHandling: 'preserve',
          });
        } else if (formType === 'pip') {
          this.router.navigate(['/insured/pip-consent'], {
            queryParamsHandling: 'preserve',
          });
        }
        return;
      }
    }

    if (formTypeStepList.length === 2) {
      /**
       * the different possibilities are
       *  UMUIM Not Started, PIP Not Started.
       * UIUM Electronic Signature, Non Digital Download or Ship Forms,
       */
      const formType1 = formTypeStepList[0].formType.toLowerCase();

      const step1 = formTypeStepList[0].step;
      const step2 = formTypeStepList[1].step;

      // both forms are Completed.
      if (
        this.requestService.isFormTypeCompleted(step1) &&
        this.requestService.isFormTypeCompleted(step2)
      ) {
        this.router.navigate(['thank-you'], {
          queryParamsHandling: 'preserve',
        });
        // this.router.navigate(['404']);
        return;
      }

      if (formType1 === 'um_uim') {
        if (this.requestService.isFormTypeCompleted(step1)) {
          let flow = 'digital';
          if (
            step1 === RequestProgressStep.NON_DIGITAL_ELECTION_DOWNLOAD ||
            step1 === RequestProgressStep.NON_DIGITAL_ELECTION_SHIP_FORMS
          ) {
            flow = 'non-digital';
            this.headerService.flowModes['uimui'] = 'non-digital';
            this.headerService.switchToNonDigital('uimui');
            this.headerService.markUIMUICompleted();
          }
          if (step1 === RequestProgressStep.ELECTRONIC_SIGNATURE) {
            this.headerService.markUIMUICompleted();
          }
          this.router.navigate(['/insured/pip-consent'], {
            queryParams: { flow: flow, key: this.requestKey },
            queryParamsHandling: 'preserve',
          });
          return;
        } else {
          this.router.navigate(['/insured/uimui-consent'], {
            queryParams: { key: this.requestKey },
            queryParamsHandling: 'preserve',
          });
        }
      }
    }
  }
}
